<template>
  <div class="cooperative-partner">
    <banner hasDivider clazz="cooperative-partner-banner" url="cooperativePartner">
      <template slot="buttons">
        <el-button class="banner-button" round @click="goRegister('hezuohuobang-banner-jihua')">加入合作伙伴计划</el-button>
        <el-button class="banner-button" round @click="this.goConsult">立即咨询</el-button>
      </template>
    </banner>
      <div class="cooperative-partner-section">
      <div class="section-content">
        <h1 class="section-title">合作伙伴体系</h1>
        <div class="section-divider"></div>
        <div class="section-main">
          <ul class="main-ul clearfix">
            <li class="main-li fl" v-for="(item, index) in sectionData" :key="index">
              <img class="main-img" :src="item.img" alt="合作伙伴体系">
              <div class="main-detail">
                <h2 class="main-title">{{item.title}}</h2>
                <div class="main-content">{{item.content}}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="cooperative-partner-section1">
      <h1 class="section1-title">合作伙伴支持</h1>
      <div class="section1-divider"></div>
      <div class="section1-content">
          <ul class="section1-main clearfix">
               <li class="section1-detail fl"  v-for="(item, index) in section1Data" :key="index">
                  <img class="detail-img" v-lazy="item.src" :alt="item.title">
                  <h2 class="detail-title">{{item.title}}</h2>
                  <p class="detail-content" v-html="item.content.replace(/@/g, '<br/>')"></p>
              </li>
          </ul>
      </div>
    </div>
    <div class="cooperative-partner-section2">
        <div class="section2-content">
          <h1 class="section2-title">不断推进合作伙伴的专业化协作</h1>
          <div class="section2-divider"></div>
          <div class="section2-main">
                <el-carousel :interval="3000" arrow="always">
                    <el-carousel-item v-for="(item, index) in partnerData" :key="index">
                    <div class="main-region">
                        <ul class="main-content clearfix">
                            <li class="content-detail fl" v-for="(item1,index1) in item" :key="index1">
                                <img class="detail-img" v-lazy="$global.globalPath + item1.cover" alt="不断推进合作伙伴的专业化协作">
                            </li>
                        </ul>
                    </div>
                    </el-carousel-item>
                </el-carousel>
          </div>
      </div>
    </div>
    <div class="cooperative-partner-section3">
      <div class="section3-content">
        <h1 class="section3-title">申请流程及条件</h1>
        <div class="section3-divider"></div>
        <div class="section3-main">
            <img class="main-img" src="../../assets/img/cooperativePartner/section3.png" alt="申请流程及条件">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '../common/banner.vue'

export default {
  inject: ['openRegister', 'goConsult'],
  name: 'CooperativePartner',
  metaInfo () {
    return {
      title: this.$seo.cooperativepartner.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.cooperativepartner.keywords
      },
      {
        name: 'description',
        content: this.$seo.cooperativepartner.description
      }]
    }
  },
  components: {
    banner
  },
  data () {
    return {
      sectionData: [
        {
          img: require('../../assets/img/cooperativePartner/1_icon.png'),
          title: '销售和实施代理',
          content: '拥有企业信息化系统销售、实施交付能力的具有独立法人资质的企业，通过参与产品解决方案完善、项目咨询、项目售前、项目交付工作，协同为客户提供服务'
        },
        {
          img: require('../../assets/img/cooperativePartner/2_icon.png'),
          title: '咨询合作伙伴',
          content: '战略咨询、采购/供应链资讯、采购管理能力培训等资讯业务公司'
        },
        {
          img: require('../../assets/img/cooperativePartner/3_icon.png'),
          title: '采购供应资源伙伴',
          content: '各领域/行业商城，招投标资源平台，可提供海量优质货源，供应商资源等合作伙伴'
        },
        {
          img: require('../../assets/img/cooperativePartner/4_icon.png'),
          title: '生态合作伙伴',
          content: '围绕采购业务过程的和上下游相关业务的软硬件产品及服务商，共同为客户提升一体化应用解决方案，提升客户满意度'
        }
      ],
      section1Data: [
        {
          title: '管理支持',
          content: '提供基于市场营销，实施服务，团队@建设，运营管理等各方面等标准化支@持辅导。',
          src: require('../../assets/img/cooperativePartner/section1-1.png')
        },
        {
          title: '培训支持',
          content: '专属合作伙伴拓展经理提供业务支@持和商务支持，帮助您在云计算领@域取得成功。',
          src: require('../../assets/img/cooperativePartner/section1-2.png')
        },
        {
          title: '市场和营销支持',
          content: '客户沙龙、研讨会、行业展会甄云@用户大会等丰富等市场和营销大会。',
          src: require('../../assets/img/cooperativePartner/section1-3.png')
        },
        {
          title: '技术和服务支持',
          content: '专项技术领域获得甄云专业架构师@团队的技术支持，在垂直市场获得@技术优势。',
          src: require('../../assets/img/cooperativePartner/section1-4.png')
        }
      ],
      partnerData: []
    }
  },
  methods: {
    goRegister (code) {
      this.openRegister(false, code)
    },
    // 获取合作伙伴
    getPartnerData () {
      this.$api.post('/news/partner', '', (r) => {
        if (r.code === 0) {
          var arr = r.data
          var num = Math.ceil(arr.length / 10)
          var arr1 = new Array(num)
          for (var i = 0; i < arr1.length; i++) {
            arr1[i] = []
          }
          for (var j = 0; j < arr.length; j++) {
            arr1[parseInt(j / 10)][j % 10] = arr[j]
          }
          this.partnerData = arr1
        } else {
          this.$message.error(r.message)
        }
      })
    }
  },
  created () {
  },
  mounted () {
    this.getPartnerData()
  }
}
</script>
<style lang="scss" >
  @import "../../../static/css/cooperativePartner.scss";
</style>



// WEBPACK FOOTER //
// cooperativePartner.vue?1e1d776a